function n(n,i){-1===n.indexOf(i)&&n.push(i)}function i(n,i){const c=n.indexOf(i);c>-1&&n.splice(c,1)}export{n as addUniqueItem,i as removeItem};
